import React from 'react';
import { SofaIcon, BedDoubleIcon, LampFloorIcon, ShowerHeadIcon, UtensilsCrossedIcon, LampDeskIcon, PanelTopIcon, RulerIcon, ChefHat } from 'lucide-react';
interface CategorySelectorProps {
  selectedCategory: string;
  hoveredCategory: string;
  isExpanded?: boolean;
  onCategorySelect: (category: string) => void;
}
export const CategorySelector = ({
  selectedCategory,
  hoveredCategory,
  isExpanded = false,
  onCategorySelect
}: CategorySelectorProps) => {
  const categories = [{
    id: 'ukseliistud',
    label: 'DIIVAN',
    icon: <SofaIcon size={20} data-id="element-14" />
  }, {
    id: 'põrandaliistud',
    label: 'VOODI',
    icon: <BedDoubleIcon size={20} data-id="element-15" />
  }, {
    id: 'valisnurgad',
    label: 'KÖÖK',
    icon: <ChefHat size={20} data-id="element-16" />
  }, {
    id: 'lävepakud',
    label: 'ELUTOA VALGUS',
    icon: <LampFloorIcon size={20} data-id="element-17" />
  }, {
    id: 'sisenurgad',
    label: 'VANNITUBA',
    icon: <ShowerHeadIcon size={20} data-id="element-18" />
  }, {
    id: 'nelikantulistud',
    label: 'PÕRANDALIISTUD',
    icon: <RulerIcon size={20} data-id="element-19" />
  }, {
    id: 'seinapaneelid',
    label: 'SÖÖGILAUD',
    icon: <UtensilsCrossedIcon size={20} data-id="element-20" />
  }, {
    id: 'klotsid',
    label: 'MAGAMISTOA VALGUS',
    icon: <LampDeskIcon size={20} data-id="element-21" />
  }, {
    id: 'dekoorid',
    label: 'SEINAPANEELID',
    icon: <PanelTopIcon size={20} data-id="element-22" />
  }];
  return <div className="flex overflow-x-auto py-2 px-4 gap-4 border-b border-gray-200" style={{
    position: 'relative',
    overflow: 'visible'
  }} data-id="element-23">
      {categories.map(category => <div key={category.id} className="relative" style={{
      zIndex: hoveredCategory === category.id ? 200 : selectedCategory === category.id && isExpanded ? 100 : 1
    }} data-id="element-24">
          <button className={`flex flex-col items-center justify-center px-4 py-2 rounded-md min-w-max transition-all duration-300 transform
              ${selectedCategory === category.id && isExpanded ? 'bg-orange-100 text-orange-500 scale-110 shadow-lg ring-2 ring-orange-500' : hoveredCategory === category.id ? 'bg-orange-50 scale-110 shadow-xl ring-2 ring-orange-300' : 'hover:bg-gray-100 hover:scale-105 hover:shadow-sm'}`} onClick={() => onCategorySelect(category.id)} style={{
        transformOrigin: 'center bottom',
        position: 'relative',
        transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        animation: hoveredCategory === category.id && !isExpanded ? 'enhanced-bounce 2.5s cubic-bezier(0.33, 0, 0.1, 1) infinite, pulse-aura 2.5s cubic-bezier(0.33, 0, 0.1, 1) infinite' : 'none'
      }} data-id="element-25">
            <div className={`relative transform transition-transform duration-300 ${selectedCategory === category.id && isExpanded || hoveredCategory === category.id && !isExpanded ? 'scale-110 text-orange-500' : ''}`} data-id="element-26">
              {category.icon}
              {hoveredCategory === category.id && !isExpanded && <div className="absolute -top-2 -right-2 w-4 h-4" data-id="element-27">
                  <div className="absolute w-full h-full bg-orange-300 rounded-full animate-ping" data-id="element-28" />
                  <div className="absolute w-full h-full bg-orange-400 rounded-full" style={{
              animation: 'sparkle 2.5s cubic-bezier(0.33, 0, 0.1, 1) infinite'
            }} data-id="element-29" />
                </div>}
            </div>
            <span className={`text-xs mt-1 font-medium transition-colors duration-300 ${selectedCategory === category.id && isExpanded ? 'text-orange-500' : hoveredCategory === category.id && !isExpanded ? 'text-orange-600' : 'text-gray-600'}`} data-id="element-30">
              {category.label}
            </span>
            {hoveredCategory === category.id && !isExpanded && <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 w-12 h-0.5 bg-orange-400 rounded-full animate-pulse" data-id="element-31" />}
          </button>
        </div>)}
    </div>;
};